import types from "../types"

/* Mark that this entity no longer required */
export default function release(
  model,
  id,
  force, // Ignore all forms
) {
  return {
    type: types.release,
    model,
    id,
    force,
  }
}
